import api from "@/services/Api";

export default {
  async insertCity({ dispatch }, city) {
    let resp = api.post("cities", city);
    return resp.data;
  },
  async listCities({ commit }) {
    let { data } = await api.get("cities");
    return data.data;
  },
  async listCitiesByStateID({ commit }, id) {
    let { data } = await api.get(`cities/state/${id}`);
    return data;
  },
  async listCitiesByStateWithFarm({ commit }, id) {
    let { data } = await api.get(`cities/state/${id}/with-farm`);
    return data;
  },
  async getCity({}, id) {
    let { data } = await api.get("cities/" + id);
    return data;
  },
};
